// extracted by mini-css-extract-plugin
export default {"wrapper":"FailureViewRepairerTabContent_wrapper__z5S-A"};